// extracted by mini-css-extract-plugin
export default {"root":"OXtR1SgwZim1npJQjFiQ","contentWrapper":"MZT9P8FqSmL8JYor3wYB","leftSection":"YjlUMSJbG_NP0DT6C0ZO","rightSection":"iGC5HFLgfv1yC_9W_L4Q","triangle":"O0x1Oj6kAg2nIVmnOB6O"};